import { Oval } from "react-loader-spinner";

export function PageLoader() {
  return (
    <div className="h-screen w-full flex items-center justify-center">
      <Oval color="red" />
    </div>
  );
}
